const DEFAULT_FIELDS = ['hasService', 'productLine', 'index']

const FIELD_DESCRIPTIONS = {
  hasService: 'Does this product belong to this service? Editable, not required on create. Options: YES - adds the product to the service; NO - removes the product from the service; leave blank to not change the current state.',
  productLine: 'Which product line, if any, does this product belong to at this service? Editable, not required on create.',
  index: 'If applicable, what is this product’s index within its product line? Editable, not required on create. Number only.'
}

const serviceIdToColumnBase = serviceId =>
  serviceId.replace('program:', 'programs.').replace(':service:', '.services.')

const byServiceIdAsc = (a, b) => a.localeCompare(b)

const isWarehouseService = serviceId => serviceIdToColumnBase(serviceId).includes('.warehouse')

const normalizeServiceIds = (serviceIds = [], { excludeWarehouse = true, sort = 'serviceIdAsc' } = {}) => {
  const filtered = Array.from(new Set(serviceIds))
    .filter(Boolean)
    .filter(serviceId => !excludeWarehouse || !isWarehouseService(serviceId))

  if (sort === 'serviceIdAsc') {
    return filtered.sort(byServiceIdAsc)
  }

  if (typeof sort === 'function') {
    return filtered.sort(sort)
  }

  return filtered
}

const getServiceIdsFromConfigurationDocs = (configurationDocs = [], opts = {}) => {
  const serviceIds = configurationDocs.map(doc => doc.service)
  return normalizeServiceIds(serviceIds, opts)
}

const getServiceFromProduct = (product, serviceId) => {
  const services = product && Array.isArray(product.services) ? product.services : []
  return services.find(service => service.id === serviceId)
}

const getHasServiceValue = service => (service ? 'YES' : '')

const getFieldValue = (service, field) => {
  if (!service) return ''
  return service[field] === undefined ? '' : service[field]
}

const buildServiceColumns = (serviceIds = [], {
  excludeWarehouse = true,
  sort = 'serviceIdAsc',
  fields = DEFAULT_FIELDS
} = {}) => {
  const normalizedServiceIds = normalizeServiceIds(serviceIds, { excludeWarehouse, sort })
  const additionalColumns = {}

  for (const serviceId of normalizedServiceIds) {
    const servicePath = serviceIdToColumnBase(serviceId)

    for (const field of fields) {
      const key = `${servicePath}.${field}`

      additionalColumns[key] = {
        title: key,
        description: FIELD_DESCRIPTIONS[field] || '',
        transform: product => {
          const service = getServiceFromProduct(product, serviceId)
          if (field === 'hasService') {
            return getHasServiceValue(service)
          }
          return getFieldValue(service, field)
        }
      }
    }
  }

  return additionalColumns
}

module.exports = {
  DEFAULT_FIELDS,
  serviceIdToColumnBase,
  getServiceIdsFromConfigurationDocs,
  buildServiceColumns
}
